module.exports = __webpack_public_path__ + "img/1542422223.cce2a3e6.jpg";